<template>
  <van-dialog
    v-model="visible"
    :title="title"
    :show-confirm-button="false"
    close-on-click-overlay
  >
    <button type="button" class="aroma-pay-dialog__action is-primary" @click="confirmStatus">查询支付结果</button>
    <button type="button" class="aroma-pay-dialog__action" @click="retry">支付遇到问题，重新支付</button>
    <button type="button" class="aroma-pay-dialog__action" @click="cancel">取消</button>
  </van-dialog>
</template>

<script>
export default {
  name: 'AromaPayBackDialog',

  data () {
    return {
      visible: false,
      payType: 'wechat'
    }
  },

  computed: {
    title () {
      return this.payType === 'wechat' ? '请确认微信支付是否完成' : '请确认支付宝支付是否完成'
    }
  },

  methods: {
    show (payType) {
      this.payType = payType
      this.visible = true
    },

    confirmStatus () {
      this.visible = false
      this.$emit('confirm')
    },

    retry () {
      this.visible = false
      this.$emit('retry')
    },

    cancel () {
      this.visible = false
      this.$emit('cancel')
    }
  }
}
</script>

<style scoped lang="scss">
.aroma-pay-dialog__action {
  display: block;
  width: 100%;
  min-height: 50px;
  color: #646a73;
  font-size: 16px;
  background: #fff;
  border-top: 1px solid #eee;
  touch-action: manipulation;

  &.is-primary {
    color: #ff4c45;
  }
}
</style>
